export default __webpack_public_path__ + "static/media/mobile-signup-bottom.228d89ea.svg";